/**
 * Path: packages/frontend/src/core/keys.ts
 * Task: Defines strongly typed injection keys for Vue's provide/inject dependency injection pattern.
 */
import type { InjectionKey, Ref } from 'vue';
import type { Entity } from '@/core/types/editor';

export interface FormContext {
  entity: Ref<Entity | null>;
  entityId: Ref<string | null>;
  isLocked: Ref<boolean>;
  isSecondary: boolean;
  isDraft: boolean; // Unterscheidet den Erstellungs-Kontext
}

// CRITICAL FIX: Use Symbol.for() instead of Symbol() to prevent reactivity loss during Vite Hot Module Replacements (HMR)!
export const FormContextKey = Symbol.for('FormContext') as InjectionKey<FormContext>;
